import { getNumberRoutes } from '../../../../src/app/get-number/get-number.routes';
import { firstStepsRoutes } from '../../../../src/app/first-steps/first-steps.routes';

const NUMBER_REQUIRED = { type: 'NUMBER_REQUIRED', redirectTo: '/first-steps', redirectToState: 'blocked.first-steps' };

export default class NumbersStateService {
  [x: string]: any;

  static $inject = ['MsisdnsService', '$q', 'ipUserInfo', 'AmplitudeService', 'AccountService'];

  constructor(MsisdnsService, $q, ipUserInfo, AmplitudeService, AccountService) {
    this.msisdnsService = MsisdnsService;
    this.$q = $q;
    this.ipUserInfo = ipUserInfo;
    this.amplitude = AmplitudeService;
    this.accountService = AccountService;
  }

  private isFullyConfigured: any;

  fetchNumbersAndBlockingStatus() {
    this.fetchAccountConfig();

    return this.$q((resolve, reject) => this.msisdnsService.query((res) => {
      this.numbers = res;

      this.isFullyConfigured.promise.then((isFullyConfigured) => {
        if (isFullyConfigured || this.pathDoesNotRequireFullConfiguration()) {
          resolve();
        } else {
          reject(this.rejectReason());
        }
      });
    }, () => reject(this.rejectReason())));
  }

  private pathDoesNotRequireFullConfiguration(): boolean {
    const { href: currentUrl } = window.location;
    return notFullyConfiguredAwarePaths.some(path => currentUrl.includes(path));
  }

  hasNumbers() {
    return this.numbers && this.numbers.length > 0;
  }

  fetchAccountConfig() {
    this.isFullyConfigured = this.$q.defer();
    this.accountService.getAccountConfig().subscribe((conf) => {
      this.isFullyConfigured.resolve(conf.data);
    });
  }

  rejectReason() {
    return Object.assign(NUMBER_REQUIRED);
  }
}


const notFullyConfiguredAwarePaths: string[] =
  [...getNumberRoutes.map(({ path }) => path),
    ...firstStepsRoutes.map(({ path }) => path)
  ];
